<template>
  <Transition name="loader">
    <div v-if="isLoading" class="global-loader">
      <div class="loader-backdrop" />
      <div class="loader-content">
        <div class="loader-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
        <p v-if="loadingText" class="loader-text">{{ loadingText }}</p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useGlobalLoader } from "@/composables/useGlobalLoader";

const { isLoading, loadingText } = useGlobalLoader();
</script>

<style lang="scss" scoped>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.loader-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 10, 15, 0.8);
  backdrop-filter: blur(4px);
}

.loader-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: rgba(25, 25, 35, 0.9);
  border-radius: 16px;
  border: 1px solid rgba(232, 65, 66, 0.2);
  box-shadow:
    0 0 40px rgba(232, 65, 66, 0.15),
    0 4px 16px rgba(0, 0, 0, 0.3);
}

.loader-spinner {
  width: 60px;
  height: 60px;
  position: relative;
  display: inline-block;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #e84142;
  animation: spin 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;

  &:nth-child(2) {
    animation-delay: -0.375s;
    border-top-color: #ff6b6c;
    transform: scale(0.8);
  }

  &:nth-child(3) {
    animation-delay: -0.75s;
    border-top-color: #e84142;
    transform: scale(0.6);
  }

  &:nth-child(4) {
    animation-delay: -1.125s;
    border-top-color: #ff9a9b;
    transform: scale(0.4);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg) scale(var(--scale, 1));
    opacity: 1;
  }
  50% {
    transform: rotate(180deg) scale(calc(var(--scale, 1) * 1.1));
    opacity: 0.8;
  }
  100% {
    transform: rotate(360deg) scale(var(--scale, 1));
    opacity: 1;
  }
}

.loader-text {
  margin-top: 1.5rem;
  margin-bottom: 0;
  color: color-mix(in srgb, var(--sem-text) 90%, transparent);
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.6;
  }
}

// Анимации появления/исчезновения
.loader-enter-active,
.loader-leave-active {
  transition: opacity 0.3s ease;

  .loader-content {
    transition:
      transform 0.3s ease,
      opacity 0.3s ease;
  }
}

.loader-enter-from,
.loader-leave-to {
  opacity: 0;

  .loader-content {
    transform: scale(0.8);
    opacity: 0;
  }
}
</style>
